import { render, staticRenderFns } from "./notification-stream.component.vue?vue&type=template&id=39c2f53a"
import script from "./notification-stream.component.vue?vue&type=script&lang=js"
export * from "./notification-stream.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports